import type { ReactNode } from 'react';
import { ImageLightboxProvider } from '@/components/common/ImageLightbox';
import { ThemeProvider } from '@/shared/contexts/ThemeProvider';

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <ThemeProvider>
      <ImageLightboxProvider>{children}</ImageLightboxProvider>
    </ThemeProvider>
  );
};
